import {getSiteUrl} from "@/helpers/functions";

export interface LocalBusinessAddress {
    streetAddress: string;
    addressLocality: string;
    addressRegion?: string;
    postalCode: string;
    addressCountry: string;
}

export interface SeoSchemaLocalBusinessProps {
    id?: string;
    name?: string;
    telephone?: string;
    email?: string;
    address?: LocalBusinessAddress;
    urlPath?: string;
}

const DEFAULT_ADDRESS: LocalBusinessAddress = {
    streetAddress: "3131 Western Ave, Suite 325",
    addressLocality: "Seattle",
    addressRegion: "WA",
    postalCode: "98121",
    addressCountry: "US",
};

export function SeoSchemaLocalBusiness({
                                           id = "business-seattle",
                                           name = "ACTIVE — Seattle",
                                           telephone = "+1-415-320-6209",
                                           email,
                                           address = DEFAULT_ADDRESS,
                                           urlPath = "/contact-us",
                                       }: SeoSchemaLocalBusinessProps = {}) {
    const siteUrl = getSiteUrl();
    const schema: Record<string, unknown> = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": `${siteUrl}/#${id}`,
        "parentOrganization": {"@id": `${siteUrl}/#organization`},
        "name": name,
        "address": {
            "@type": "PostalAddress",
            ...address,
        },
        "telephone": telephone,
        "url": `${siteUrl}${urlPath.startsWith("/") ? "" : "/"}${urlPath}`,
    };

    if (email) {
        schema.email = email;
    }

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
